function getArrayFilters(filters) {
  if (Array.isArray(filters)) {
    return filters
  }

  return [filters]
}

export default getArrayFilters
